<template>
  <v-container fluid fill-height class="pa-0" style="min-height: 100vh;">
    <v-row no-gutters class="fill-height">
      <!-- Sidenav (Imagen de fondo) -->
      <v-col cols="12" md="5" class="sidenav d-flex justify-center align-center">
        <img src="../assets/cucurucho-n.jpg" alt="Logo" class="logo-image" />
      </v-col>
      
      <!-- Formulario Principal -->
      <v-col cols="12" md="7" class="d-flex justify-center align-center">
        <v-card elevation="0" class="pa-8" width="100%" max-width="500">
          <v-card-text>
            <form @submit.prevent="login">
              <v-text-field
                v-model="usuario"
                label="Usuario"
                placeholder="Ingresa tu usuario"
                outlined
                dense
                required
                :disabled="loading"
              ></v-text-field>

              <v-text-field
                v-model="password"
                label="Password"
                type="password"
                placeholder="Ingresa tu contraseña"
                outlined
                dense
                required
                :disabled="loading"
              ></v-text-field>

              <v-btn
                type="submit"
                block
                color="black"
                dark
                class="mt-4 py-6"
                :loading="loading"
              >
                Iniciar Sesión
              </v-btn>

              <v-snackbar v-model="error" :timeout="5000" color="error" top right>
                {{ error_msg }}
                <template v-slot:action="{ attrs }">
                  <v-btn text v-bind="attrs" @click="error = false">
                    Cerrar
                  </v-btn>
                </template>
              </v-snackbar>
            </form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>


<script>
// @ is an alias to /src
import axios from "axios";
import { EncryptionService } from "../utils/encryption";

export default {
  name: "LoginView",
  components: {},
  data: function () {
    return {
      usuario: "",
      password: "",
      error: false,
      error_msg: "",
      loading: false,
    };
  },
  async mounted() {
    await EncryptionService.init();
  },
  methods: {
    async getProfile() {
      const apiUrl = `https://adcl0t3ai4.execute-api.us-east-1.amazonaws.com/dev/api/profile?user=${this.$cookies.get("user")}`;

      const token = this.$cookies.get("token");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };


      axios
        .get(apiUrl, config)
        .then((response) => {


          const records = response.data.records;


          // Verificar si 'records' es un array y tiene al menos un elemento
          if (!Array.isArray(records) || records.length === 0) {
            console.error("🚨 'records' no es un array válido o está vacío:", records);
            return;
          }

          const perfil = records[0]; // Tomar el primer elemento del array
          // Extraer datos correctamente
          const { nombre_hermandad, logo, cuiReq, templateRecibo, montoCustom, correo } = perfil;

          // Guardar en cookies
          this.$cookies.set("hermandad", nombre_hermandad, "1d", "", "", true, "Strict");
          this.$cookies.set("logo", logo, "1d", "", "", true, "Strict");
          this.$cookies.set("cuiReq", cuiReq, "1d", "", "", true, "Strict");
          this.$cookies.set("templateRecibo", templateRecibo, "1d", "", "", true, "Strict");
          this.$cookies.set("montoCustom", montoCustom, "1d", "", "", true, "Strict");
          this.$cookies.set("correoH", correo, "1d", "", "", true, "Strict");

        })
        .catch(() => {

          this.showSessionExpiredDialog = true;
          // console.error(error)
          // console.error('Error al obtener datos de la API', error);
          // this.loading = false; // Desactivar animación de carga en caso de error
        });
    },
    async login() {
      this.loading = true;
      // URL de la API de login
      const loginUrl = "https://wm1xvvtarj.execute-api.us-east-1.amazonaws.com/dev/login";

      // Encriptar password
      // Encriptar password
      const encryptedPassword = await EncryptionService.encrypt(this.password);
      const encryptedUsername = await EncryptionService.encrypt(this.usuario);
      
      
      if (!encryptedPassword || !encryptedUsername) {
         this.error = true;
         this.error_msg = "Error al cifrar credenciales. Intente nuevamente.";
         this.loading = false;
         return;
      }

      // Cuerpo de la solicitud para obtener el jwtToken
      const loginData = {
        username: encryptedUsername,
        password: encryptedPassword,
      };

      // Realizar solicitud POST para obtener el jwtToken
      axios
        .post(loginUrl, loginData)
        .then((response) => {
          if (response.data.status === "Ok") {
            this.error = false;
            this.error_msg = "";
            this.loading = false; // Ocultar animación de carga
            const token = response.data.jwtToken;
            this.$cookies.set("user", this.usuario, "1d", "", "", true, "Strict");
            this.$cookies.set("token", token, {
              expires: "1d",
              secure: true,
              httpOnly: true,
              sameSite: "Strict",
            });
            // Verificar que se ha establecido correctamente
            //localStorage.token = response.data.jwtToken;
            //localStorage.user = this.usuario;
            this.$nextTick(() => {
              if (this.$cookies.get("token") && this.$cookies.get("user")) {
                // Espera hasta que se haya establecido la cookie para usuario
                if (this.$cookies.get("user")) {
                  this.getProfile();
                  this.$router.push("dashboard");
                } else {
                  console.error("Error: la cookie 'username' no se ha establecido correctamente.");
                }
              } else {
                console.error("Error: las cookies no se establecieron correctamente.");
              }
            });

          } else {
            // console.error('Error en el inicio de sesión:', response.data);
            this.error = true;
            this.error_msg = response.data.error_msg;
            this.loading = false;
          }
        })
        .catch(() => {
          // console.error('Error al iniciar sesión', error);
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.logo-image {
  max-width: 70%;
  height: auto;
}

body {
  font-family: "Lato", sans-serif;
}

.sidenav {
  background-color: #101211;
  min-height: 100vh;
}
</style>
